<template>
  <span v-if="d != null" class="sd-delta" :class="d >= 0 ? 'up' : 'dn'">{{ d >= 0 ? '▲' : '▼' }} <span class="num-ltr">{{ Math.abs(Math.round(d * 10) / 10) }}{{ unit || '' }}</span></span>
</template>
<script>
export default { name: 'SdDeltaChip', props: { d: { type: Number, default: null }, unit: String } }
</script>
